<template>
  <v-breadcrumbs
    :key="$route.path"
    :dark="$vuetify.theme.isDark"
    class="pa-0"
    :items="breadcrumbs?.trail"
  >
    <template #item="{ item, index }">
      <v-breadcrumbs-item
        :key="item.text"
        :to="item.to || undefined"
        :disabled="item.disabled || !item.to"
        exact
      >
        <span class="text-body-2 font-weight-bold text-capitalize">{{
          item.text
        }}</span>
      </v-breadcrumbs-item>
    </template>
  </v-breadcrumbs>
</template>

<script>
export default {
  name: "Breadcrumbs",
  computed: {
    breadcrumbs() {
      const routesWithTrail = this.$route.matched.filter(
        (route) => typeof route.meta?.trail === "function",
      );
      if (!routesWithTrail.length) {
        return { trail: [] };
      }
      const route = routesWithTrail[routesWithTrail.length - 1];
      const trail = route.meta.trail(this.$route);
      return {
        text: route.meta.text,
        disabled: false,
        to: route.path,
        trail: trail.map((item) => ({
          text: item.text,
          to: item.to || undefined,
          disabled: item.disabled !== undefined ? item.disabled : !item.to,
        })),
      };
    },
  },
};
</script>
